export const KEY_SPLIT = '_'

export interface VesselManagementState {
    ownVessels: any[]
    hiredVessels: any[]
    loadingList: boolean
    loadingContract: boolean
}

export const initialState: VesselManagementState = {
    ownVessels: [],
    hiredVessels: [],
    loadingList: false,
    loadingContract: false,
}

